module.exports = __webpack_public_path__ + "media/bootstrap-icons/inbox-2ebc6f16.svg";